var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"increment-decrement-button"},[_c('button',{on:{"click":_vm.decrement}},[_vm._v("-")]),_c('span',[_vm._v(_vm._s(_vm.getValue()))]),_c('button',{on:{"click":_vm.increment}},[_vm._v("+")])])}
var staticRenderFns = []

export { render, staticRenderFns }